import urlConfig from 'Url';

export const REALNAME_VERIFY = 'REALNAME_VERIFY';
export const SUBMIT_APPLY_TAORDER = 'SUBMIT_APPLY_TAORDER';
export const REAL_NAME_VERIFY = 'REAL_NAME_VERIFY';
export const CLEAR_REAL_NAME_VERIFY = 'CLEAR_REAL_NAME_VERIFY';
export const GET_BANKCARD_DATA = 'GET_BANKCARD_DATA';
export const BANKCARD_DATA = 'BANKCARD_DATA';

export function realNameVerify(data) {
  return {
    type: REALNAME_VERIFY,
    payload: {
      request: {
        url: urlConfig.identityPayAuthInfo,
        method: 'post',
        data,
      },
    },
  };
}

export function saveVerify(data) {
  return { type: REAL_NAME_VERIFY, realNameVerifyResult: data };
}

// 提交TA单
export function submitApplyTAOrder(data, load = false) {
  return {
    type: SUBMIT_APPLY_TAORDER,
    closeLoading: load,
    payload: {
      request: {
        url: urlConfig.createRefundTa,
        method: 'post',
        data,
      },
    },
  };
}

export function getbankcarddata(data) {
  return {
    type: GET_BANKCARD_DATA,
    payload: {
      request: {
        url: urlConfig.searchAuthInfo,
        method: 'post',
        data,
      },
    },
  };
}

export function savebankcarddata(data) {
  return { type: BANKCARD_DATA, bankcarddata: data };
}



// WEBPACK FOOTER //
// ./src/routes/routes/realNameVerify/modules/actions.js